<template>
  <FormSection>
    <h1 class="mt-4 text-balance text-2xl font-bold text-gray-500 lg:text-3xl">
      {{ $t('account.recover.title') }}
    </h1>
    <p class="mt-4 font-medium max-md:text-sm">
      {{ $t('account.recover.text') }}
    </p>
    <form class="mt-4 bg-white p-4" @submit.prevent="submit">
      <InputText
        v-model="email"
        :required="true"
        :label="$t('form.label.email')"
        autocomplete="email"
      />
      <AppButton
        class="ml-auto mt-4"
        :disabled="!email"
        :loading="loading"
        type="submit"
      >
        {{ $t('account.recover.reset') }}
      </AppButton>
    </form>
  </FormSection>
</template>

<script setup lang="ts">
import type { ApiError } from '@shopware/api-client'

const { t } = useI18n()
const { resetPassword, errors: shopwareErrors } = useCustomerPassword()
const { pushError, pushSuccess } = useNotifications()
const { isLoggedIn } = useUser()
const router = useRouter()
const localePath = useLocalePath()
const { getStorefrontUrl } = useInternationalization()

const email = ref('')
const loading = ref(false)

const errors = computed<ApiError[]>(() => shopwareErrors.resetPassword.errors)

if (isLoggedIn.value) {
  router.push(localePath('/shop/account'))
}

const submit = async () => {
  try {
    loading.value = true
    const emailSent = await resetPassword({
      email: email.value,
      storefrontUrl: getStorefrontUrl(),
    })
    if (emailSent) {
      pushSuccess(t('account.recover.success'), {
        persistent: true,
      })
      await router.push(localePath('/shop/login'))
    } else {
      errors.value.forEach(({ detail }) => {
        if (detail) {
          pushError(detail)
        }
      })
    }
  } catch (error) {
    console.error(error)
    pushError(t('account.recover.error'))
  } finally {
    loading.value = false
  }
}
</script>
